<template>
    <v-app-bar class="bt-navbar" app v-if="showMenu">
        <div class="pa-5" style="display: flex; align-items: center; justify-content: space-between; width: 100%">
            <div style="display: flex; align-items: center">
                <v-icon @click="goBack" color="purple" icon="mdi-keyboard-backspace"></v-icon>
                <div>
                    <h3 class="pl-3 text-body-1 font-weight-bold" style="color: #450a54;">{{ route.name }}</h3>
                </div>
            </div>
            <!-- <Notif /> -->
            <div v-if="userType === 4">
                <RouterLink to="/logout">
                    <v-icon size="24" color="amber-darken-2" class="rounded-circle"
                        style="cursor: pointer; background-color: #FFFDE7; padding: 15px; display: inline-flex; align-items: center; justify-content: center;">
                        mdi-logout
                    </v-icon>
                </RouterLink>
            </div>
        </div>
    </v-app-bar>
</template>

<script setup>
import { useMainStore } from "@/store";
import { computed, ref, watchEffect } from "vue";
import { useRoute, useRouter } from "vue-router";


const showMenu = ref(true);
const router = useRouter();
const route = useRoute();
const store = useMainStore();
const user = computed(() => store.user)
const userType = computed(() => user.value?.type)

function goBack() {
    router.back();
}
watchEffect(() => {
    showMenu.value = !["Home", "Login", "Logout", "Welcome", "Forgot Password", "Reset Password", "DetailTransaksi", "Home Petugas", "Halaman Tidak Ditemukan"].includes(route.name);
});
</script>

<style scoped>
.v-app-bar.bt-navbar {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    max-width: 480px;
    width: 100%;
    z-index: 10;

    background-color: rgba(255, 255, 255, 0.3) !important;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.1);
}
</style>
